export const buildResponse = (eventParams) => {
  return {
    event: eventParams,
  };
};
